import { Box, Text } from '@chakra-ui/react'
import { chakra } from '@chakra-ui/system'
import React from 'react'

import { Spinner } from '@/components/Spinner'
import { getChainName } from '@/lib/MetaMaskUtil'

type Props = {
  correctChainId: string
}

export const WrongChainIdWarning = ({ correctChainId }: Props) => {
  const correctChainName = getChainName(correctChainId)

  return (
    <Box mt="8" textAlign="center">
      <Box>
        <Spinner />
      </Box>
      <Box mt="4">
        <Text fontSize="xl" fontWeight="bold">
          The network is different.
        </Text>
      </Box>
      <Box>
        <Text fontWeight="bold">
          Change network to
          <chakra.span ml="1" color="#f79128">
            {correctChainName}
          </chakra.span>
        </Text>
      </Box>
    </Box>
  )
}
